<template>
  <v-row>
    <v-col
      cols="12"
      md="12"
      sm="12"
      class="pt-0"
    >
      <articles-grid />
    </v-col>
  </v-row>
</template>

<script>
import ArticlesGrid from '@/components/ArticlesGrid'

export default {
  name: 'Articles',
  components: {
    'articles-grid': ArticlesGrid
  }
}
</script>
